import javaService from "../../utils/request"
function handel(data) {
  var params = new URLSearchParams()
  for (const key in data) {
    params.append(key, data[key])
  }
  return params
}

//获取文章详情
export function getArticleDetails(data){
  return javaService({
    url: '/classificationFront/detailsPage',
    method: 'get',
    params: data,
    isLoading:true
  })
}

//收藏
export function articleCollect(data){
  return javaService({
    url: '/classificationFront/collectionArticle',
    method: 'get',
    params: data,
    isLoading:true
  })
}

//右侧相关推荐
export function rightCorrelationRecommend(data){
  return javaService({
    url: '/classificationFront/relatedRecommendations',
    method: 'get',
    params: data,
    isLoading:true
  })
}
//下面相关推荐
export function bottomRecommend(data){
  return javaService({
    url: '/front/latestArticles',
    method: 'get',
    params: data,
    isLoading:true
  })
}

//评论
export function newestComment(data){
  return javaService({
    url: '/classificationFront/relatedComments',
    method: 'get',
    params: data,
    isLoading:true
  })
}

//回复
export function addComment(data){
  return javaService({
    url: '/hkComment/addComment',
    method: 'post',
    data: handel(data),
    isLoading:true
  })
}

//附件下载
export function fileDownload(data){
  return javaService({
    url: '/hkEnclosure/nclosureDownload',
    method: 'get',
    params: data,
    isLoading:true
  })
}

//预览图
export function getthumbnailUrl(data){
  return javaService({
    url: '/classificationFront/vidoStream',
    method: 'get',
    params: data,
  })
}